import * as React from "react";
const SvgXG900 = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#191919"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
      d="m6 6 12 12M18 6 6 18"
    />
  </svg>
);
export default SvgXG900;
